// import React from 'react';
// import ReactDOM from 'react-dom';
// import Modal from 'react-modal';

// const PopOutModal = ({ isOpen, onClose, content }) => {
//     if(!isOpen)
//     return null;

//   return (
//   ReactDOM.createPortal(
//     <>
//      <div style={{ position: 'fixed',
//          top: '0',
//          left: '0',
//          right:'0',
//          bottom:'0',
//          backgroundColor: 'rgba(0,0,0,0.7)',
//          zIndex: 1000, }}></div>
//      <div
//      style={{
//          position: 'absolute',
//          top: '50%',
//          left: '50%',
//          transform: 'translate(-50%, -50%)',
//          zIndex: 1000,
//          backgroundColor:'white',

//          // Higher z-index to make it appear on top
//          // other styles...
//        }}
//        isOpen={isOpen}
//      //   onRequestClose={onClose}
//      //   contentLabel="Pop Out Modal"
//      >
//        <button onClick={onClose}>Close</button>
//        {content}
//      </div>

//     </>,
//      document.getElementById('modal') // Render the modal at the end of the document body
//   )

//   )
// };

// export default PopOutModal;
import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

const PopOutModal = ({
  isOpen,
  onClose,
  content,
  isSmall,
  widthTo = "",
  modalClose,
  bigPopUpHeight,
  heightPopUp = "",
}) => {
  const modalRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);
  const [resizeStart, setResizeStart] = useState({ x: 0, y: 0 });
  console.log(heightPopUp);

  // const handleMouseDown = (e) => {
  //   setIsResizing(true);
  //   setResizeStart({ x: e.clientX, y: e.clientY });
  // };

  // const handleMouseUp = () => {
  //   setIsResizing(false);
  // };

  // const handleMouseMove = (e) => {
  //   if (isResizing) {
  //     const width = modalRef.current.offsetWidth + e.clientX - resizeStart.x;
  //     const height = modalRef.current.offsetHeight + e.clientY - resizeStart.y;
  //     modalRef.current.style.width = `${width}px`;
  //     modalRef.current.style.height = `${height}px`;
  //     setResizeStart({ x: e.clientX, y: e.clientY });
  //   }
  // };

  return ReactDOM.createPortal(
    isOpen && (
      <>
        <div
          onClick={() => {
            // onClose()
            // if(modalClose)  modalClose();
          }}
          className="pop-out-modal"
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 100,
          }}
        ></div>
        <div
          ref={modalRef}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            width: isSmall ? widthTo : "60%",
            height: bigPopUpHeight ? "80%" : heightPopUp,
            backgroundColor: "white",
            // resize: 'both',
            overflowY: "auto",
            overflowX: "hidden",
          }}

          // onMouseDown={handleMouseDown}
          // onMouseUp={handleMouseUp}
          // onMouseMove={handleMouseMove}
        >
          <button
            onClick={() => {
              onClose();
              if (modalClose) modalClose();
            }}
            style={{
              position: "absolute",
              top: "-6px",
              right: "-6px",

              cursor: "pointer",
              fontSize: "20px",

              border: "2px",
              color: "red",
              padding: "4px",
              background: "transparent",
              overflow: "hidden",
              zIndex: 101,
              // border: '2px solid #ccc', padding: '1px 2px'
            }}
          >
            <CloseIcon />
          </button>
          {/* <i className="fa fa-times"></i> */}
          {content}
        </div>
      </>
    ),
    document.getElementById("modal")
  );
};

export default PopOutModal;
